import { getOptions } from '../EChartUtils'

class _Graph {
    constructor(obj) {
        this.obj = obj
    }

    getDefaultOptions = () => {
        return {
            name: 'graph chart',
            type: 'graph',
            layout: 'none',
            data: [],
            links: [],
            edgeSymbol: ['circle', 'arrow'],
            edgeSymbolSize: [4, 10],
            symbolSize: 50,
            label: {
                normal: {
                    show: true,
                },
            },
        }
    }

    getJson = () => {
        return getOptions(this.obj, this.getDefaultOptions(), {
            color: () => (
                {
                    lineStyle: {
                        normal: {
                            color: this.obj.color,
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: this.obj.color,
                        },
                    },
                }),
        })
    }
}

export default function Graph(args) {
    return new _Graph(args)
}


